angular.module("schemaForm").run(["$templateCache", function($templateCache) {
  $templateCache.put("directives/decorators/bootstrap/array/ranking.html",
  `<div class="{{form.htmlClass}}">
      <div class="form-group">
      <label class=\"control-label\" ng-show=\"showTitle()\">{{form.title}}</label>
      <ul ui-sortable="" ng-model="$$value$$" class="list-group">
        <li ng-repeat="item in $$value$$" class="list-group-item" style="cursor: move;">
        <span class="badge badge-primary badge-pill pull-left">#{{$index+1}}</span>
        <span style="padding-left: 8px">{{ item }}</span>
        <span class="pull-right"><i class="fa fa-fw fa-arrows"></i></span>
        </li>
      </ul>
      <div class="help-block" ng-show="(hasError() && errorMessage(schemaError())) || form.description"
          ng-bind-html="(hasError() && errorMessage(schemaError())) || form.description">
      </div>
    </div>
  </div>`
    );}]);
angular.module('schemaForm-ranking', ['schemaForm']).config(
  ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider,  schemaFormDecoratorsProvider, sfPathProvider) {

      var ranking = function(name, schema, options) {
        if (schema.type === 'array' && schema.format === 'ranking') {
          var f = schemaFormProvider.stdFormObj(name, schema, options);
          f.key = options.path;
          f.type = 'ranking';
          options.lookup[sfPathProvider.stringify(options.path)] = f;
          return f;
        }
      };

      schemaFormProvider.defaults.array.unshift(ranking);
      schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'ranking', 'directives/decorators/bootstrap/array/ranking.html');
      schemaFormDecoratorsProvider.createDirective('ranking', 'directives/decorators/bootstrap/array/ranking.html');
    }]);



// WEBPACK FOOTER //
// ./client/app/schema-form.ranking.js